var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M79.9998 5.0974H69.0538V0.40625H53.4197V16.0434H26.5801V0.40625H10.946V5.0974H0V42.6236H10.946V47.3147H26.5801V31.6776H53.4197V47.3147H69.0538V42.6236H79.9998V5.0974ZM4.68749 37.9361V9.78489H10.946V37.9361H4.68749ZM21.8927 42.6272H15.6335V5.09374H21.8927V42.6272ZM26.5801 26.9901V20.7309H53.4197V26.9901H26.5801ZM64.3663 42.6272H58.1072V5.09374H64.3663V42.6272ZM75.3124 37.9361H69.0538V9.78489H75.3124V37.9361Z",
    fill: "#C49A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility7);
export default __webpack_public_path__ + "static/media/gefion-facility-7.f32738ed3f65ba27e97093135a47539a.svg";
export { ForwardRef as ReactComponent };